import { render, staticRenderFns } from "./SelectActivityDialog.vue?vue&type=template&id=4878d8a2&scoped=true"
import script from "./SelectActivityDialog.vue?vue&type=script&lang=ts"
export * from "./SelectActivityDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4878d8a2",
  null
  
)

export default component.exports